import * as yup from 'yup';
import { userNotesFormFields } from '../../fields/formFields/userNotes';

export const noteTypes = ['request', 'event', 'action', 'other'] as const;

export type NotesType = (typeof noteTypes)[number];

export const userNotesFormSchema = yup.object({
  [userNotesFormFields.content]: yup.string().trim().required('Content is required'),

  [userNotesFormFields.type]: yup.string().oneOf(noteTypes, 'Invalid note type').required('Type is required'),
});
